import React, {
  useState,
  useContext,
} from 'react';
import {
  DateTime,
} from 'luxon';
import {
  ThemeContext,
} from 'styled-components';

import {
  toast,
} from 'react-toastify';

import {
  Icon,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

const getDate = (isoDate: string) => DateTime.fromISO(isoDate).toFormat('d LLL y');

const getDuration = (secs: number) => {
  const minutes = `${Math.floor(secs / 60)}`;
  const seconds = `${secs % 60}`;
  const stringedMinutes = minutes.length === 1 ? `0${minutes}` : `${minutes}`;
  const stringedSeconds = seconds.length === 1 ? `0${seconds}` : `${seconds}`;
  return `${stringedMinutes}:${stringedSeconds}`;
};

type Props = {
  video: any,
  readOnly: boolean,
  onRemove: { (video: any): void },
  onChangeName?: { (videoId: number, newName: string): void },
};

const Video = ({
  video,
  readOnly,
  onRemove,
  onChangeName,
}: Props) => {
  const [isPlaying, setPlay] = useState(false);
  const theme = useContext(ThemeContext);

  const handleNameChange = (newName: string) => {
    if (!readOnly && newName && newName !== video.name && onChangeName) {
      onChangeName(video.id, newName);
    }
  };

  return (
    <S.Video>
      <S.Preview
        style={{ backgroundImage: `url(${video.preview_picture_url})` }}
      >
        {isPlaying ? (
          <S.Frame
            src={`${video.embed_url}?autoplay=1`}
            allowFullScreen
          />
        ) : (
          <S.PlayIcon onClick={() => (video.embed_url ? setPlay(true) : toast.error('Video is still processing, please wait.'))}>
            <SVG.Play fill={theme.colors.link} />
          </S.PlayIcon>
        )}
      </S.Preview>
      <Flex
        width="100%"
        height="36%"
        padding="10px"
        spacing={5}
      >
        <Flex column width="100%">
          <S.EditableName
            html={(video.name || '').split('.')[0]}
            disabled={readOnly}
            onBlur={(e) => {
              handleNameChange(e.target.textContent || '');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.target.blur();
              }
            }}
          />
          <Text
            size="14px"
            weight={500}
          >
            {`Uploaded: ${getDate(video.uploaded_at || video.created_at)}`}
          </Text>
          <Flex
            margin="8px 0 0 0"
            spacing={5}
            align="center"
          >
            <Icon
              color={theme.colors.link}
              type="far fa-clock"
              size="12px"
            />
            <Text
              size="12px"
              color="#cbcacb"
              weight={500}
            >
              {getDuration(video.duration)}
            </Text>
          </Flex>
        </Flex>
        {onRemove && (<S.Remove onClick={() => onRemove(video)} />)}
      </Flex>
    </S.Video>
  );
};

Video.defaultProps = {
  onChangeName: null,
};

export default Video;
